import { Status } from "./Status";

export class ReturnStatusSmartEnum {
    static Draft = new Status("Draft", 1, "pill--yellow");
    static Submitted = new Status("Submitted", 2, "pill--blue");
    static ToPack = new Status("To Pack", 2, "pill--green");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "ReturnStatusSmartEnum";
    }
}